import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ProjectInfoService } from '../../features/project-info/services/project-info.service';
import { ApiError } from '../interceptors/error.interceptor';

export const projectExistsGuard: CanActivateFn = route => {
  const projectId = route.paramMap.get('projectId');
  const router = inject(Router);
  const projectInfoService = inject(ProjectInfoService);

  if (!projectId) {
    return router.createUrlTree(['/404']);
  }

  return projectInfoService.getProjectInfo(projectId).pipe(
    map(() => true),
    catchError(error => {
      if (error instanceof ApiError && error.status === 404) {
        return of(router.createUrlTree(['/404']));
      }
      return of(true);
    }),
  );
};
